import { KeyValue } from '@angular/common';
import { ProductTreePath, SearchSort } from '@forgerock/backstage-ui-core';
import { Source } from './search-constants';
import { Tab } from './tabs';

export interface AppSearchParamsExt {
  entityType: string[] | string;
  eosl: string;
  library: string[] | string;
  page: string;
  priority: string[] | string;
  productVersionPath: string[] | string;
  project: string[] | string;
  q: string;
  sort: string;
  source: string[] | string;
  status: string[] | string;
  t: string;
  type: string[] | string;
  tag: string[] | string;
}

export interface AppSearchParamsInt {
  entityType: string[];
  eosl: boolean;
  library: string[];
  page: number;
  priority: string[];
  productVersionPath: ProductTreePath[];
  project: string[];
  publicationType: string[];
  query: string;
  sort: SearchSort;
  source: string[];
  status: string[];
  tab: Tab;
  tags: string[];
}

export const legacyParams: { key: keyof AppSearchParamsExt; legacyKeys: string[] }[] = [
  { key: 'source', legacyKeys: [ 'dt' ] }
];

export const legacyParamMappings: { from: KeyValue<string, string>; to: Partial<AppSearchParamsExt> }[] = [
  { from: { key: 't', value: 'doc' }, to: { source: Source.DOC, t: 'pages' } }
];
